if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.isCarousel = this.classList.contains('product-media-modal--carousel');
        const prevBtn = this.querySelector('.product-media-modal__nav-button--prev');
        const nextBtn = this.querySelector('.product-media-modal__nav-button--next');
        prevBtn?.addEventListener('click', () => this.showAdjacentMedia(-1));
        prevBtn?.addEventListener('pointerup', (e) => e.stopPropagation());
        nextBtn?.addEventListener('click', () => this.showAdjacentMedia(1));
        nextBtn?.addEventListener('pointerup', (e) => e.stopPropagation());
        if (this.isCarousel) {
          this.addEventListener('keydown', (event) => {
            if (event.code === 'ArrowLeft') this.showAdjacentMedia(-1);
            if (event.code === 'ArrowRight') this.showAdjacentMedia(1);
          });
        }
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaElements() {
        return Array.from(this.querySelectorAll('[data-media-id]'));
      }

      setActiveMediaById(mediaId) {
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        this.getMediaElements().forEach((element) => element.classList.remove('active'));
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      showActiveMedia() {
        this.setActiveMediaById(this.openedBy.getAttribute('data-media-id'));
      }

      showAdjacentMedia(direction) {
        const mediaElements = this.getMediaElements();
        const activeIndex = mediaElements.findIndex((element) => element.classList.contains('active'));
        if (activeIndex === -1) return;

        const nextIndex = (activeIndex + direction + mediaElements.length) % mediaElements.length;
        this.setActiveMediaById(mediaElements[nextIndex].getAttribute('data-media-id'));
      }
    }
  );
}
